module.exports = __webpack_public_path__ + "img/4.c4f2226d.png";